<template>
  <div class="LmSummaryMeta">
    <span class="text-xxs text-gray-700">By {{ username }}</span>
    <span class="Separator ml-5px mr-1 text-gray-500" />
    <span class="text-xxs text-gray-500" :title="createdAt | formattedDate">
      {{ createdAt | dateFromNow('Now') }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'LmSummaryMeta',
  props: {
    username: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.Separator:before {
  content: '\00B7';
}
</style>
